angular.module('core')
  .service('milestoneCompletedLetterApi', ['cancelableResourceManager', 'cancelableResourceFactory', '$state', function ($cancelableResourceManager, $cancelableResourceFactory, $state) {

      var milestoneCompletedLetterUrl = 'r/districts/:districtId/students/:studentId/milestone_completed_letter/:lessonSlotId';
      var MilestoneCompletedLetter = $cancelableResourceFactory.createCacheableResource(null, milestoneCompletedLetterUrl, {}, {
          query: {
              url: milestoneCompletedLetterUrl,
              method: 'GET',
              transformResponse: function (body, headersGetter, status) {
                  return JSON.parse(body);
              }
          }
      });

      var self = this;

      self.getMilestoneCompletedLetter = function (studentId, lessonSlotId) {
          var params = {
              districtId: $state.params.districtId,
              studentId: studentId,
              lessonSlotId: lessonSlotId
          };

          var promises = MilestoneCompletedLetter.query(params);
          $cancelableResourceManager.addAndRemoveOnFinish(promises);
          return promises.$promise;
      };
  }]);
